<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="4">
          <v-card outlined>
            <v-card-text class="text-center">
              <div class="text-h3 primary--text">{{ pointsThisWeek }}</div>
              <div class="overline">Points This Week</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card outlined>
            <v-card-text class="text-center">
              <div class="text-h3 primary--text">{{ pointsThisMonth }}</div>
              <div class="overline">Points This Month</div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" class="d-flex align-center justify-center">
          <v-btn x-large block color="primary" to="/crm/log">
            <v-icon left>mdi-plus-circle</v-icon>
            Log Interaction
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="!$apollo.loading && myContacts.length === 0">
        <v-col cols="12">
          <v-alert type="info" text>
            You don't have any contacts assigned to you yet. Ask an admin to
            assign contacts on the
            <router-link to="/crm/contacts">Contacts</router-link> page.
          </v-alert>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-card-title class="red--text text--darken-2">
              <v-icon color="red darken-2" left>mdi-alert-circle</v-icon>
              Overdue ({{ overdueContacts.length }})
            </v-card-title>
            <contact-check-in-table
              :contacts="overdueContacts"
              :loading="$apollo.loading"
              empty-text="Nothing overdue. Nice work!"
            />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-card-title class="amber--text text--darken-3">
              <v-icon color="amber darken-3" left>mdi-calendar-clock</v-icon>
              Due This Week ({{ dueThisWeek.length }})
            </v-card-title>
            <contact-check-in-table
              :contacts="dueThisWeek"
              :loading="$apollo.loading"
              empty-text="Nothing coming due this week."
            />
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-card-title>
              <v-icon left>mdi-calendar-check</v-icon>
              Upcoming ({{ upcomingContacts.length }})
            </v-card-title>
            <contact-check-in-table
              :contacts="upcomingContacts"
              :loading="$apollo.loading"
              empty-text="No other assigned contacts."
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import gql from "graphql-tag";
import ContactCheckInTable from "./ContactCheckInTable";

export default {
  components: {
    ContactCheckInTable
  },
  apollo: {
    myCrmDashboard: {
      query: gql`
        query MyCrmDashboard {
          myCrmDashboard {
            pointsThisWeek
            pointsThisMonth
            contacts {
              id
              name
              phone
              tier
              lastTouch
              nextDue
              overdue
              contactType {
                name
              }
            }
          }
        }
      `,
      fetchPolicy: "cache-and-network"
    }
  },
  computed: {
    pointsThisWeek() {
      if (!this.myCrmDashboard) return 0;
      return this.formatPoints(this.myCrmDashboard.pointsThisWeek);
    },
    pointsThisMonth() {
      if (!this.myCrmDashboard) return 0;
      return this.formatPoints(this.myCrmDashboard.pointsThisMonth);
    },
    myContacts() {
      if (!this.myCrmDashboard) return [];
      return this.myCrmDashboard.contacts;
    },
    overdueContacts() {
      return this.sortByNextDue(this.myContacts.filter(c => c.overdue));
    },
    dueThisWeek() {
      let weekFromNow = new Date();
      weekFromNow.setDate(weekFromNow.getDate() + 7);
      return this.sortByNextDue(
        this.myContacts.filter(c => {
          if (c.overdue || !c.nextDue) return false;
          return new Date(c.nextDue) <= weekFromNow;
        })
      );
    },
    upcomingContacts() {
      let weekFromNow = new Date();
      weekFromNow.setDate(weekFromNow.getDate() + 7);
      return this.sortByNextDue(
        this.myContacts.filter(c => {
          if (c.overdue) return false;
          if (!c.nextDue) return true;
          return new Date(c.nextDue) > weekFromNow;
        })
      );
    }
  },
  methods: {
    formatPoints(points) {
      if (points == null) return 0;
      return points % 1 === 0 ? points : points.toFixed(1);
    },
    sortByNextDue(contacts) {
      return [...contacts].sort((a, b) => {
        if (!a.nextDue) return 1;
        if (!b.nextDue) return -1;
        return new Date(a.nextDue) - new Date(b.nextDue);
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
